import Dropdown from '@/components/Dropdown'
import { MoreHorizontal, Trash, Edit2 } from 'react-feather'
import analytics from '@/utils/analytics'
import api from '@/utils/api'
import { useRecoilState } from 'recoil'
import { modalState, deleteItem, updateItem } from '@/store'
import toast from 'react-hot-toast'

export default function PlaylistOptions({
  className = '',
  playlist,
  setPlaylists,
  mutatePlaylists,
}) {
  const [, setModal] = useRecoilState(modalState)

  function updateTitle(title) {
    try {
      analytics.track('Updating playlist title')

      api.put(`/playlists/${playlist._id}`, {
        title,
      })

      setPlaylists((prev) =>
        updateItem({
          items: prev,
          item: {
            ...playlist,
            title,
          },
        })
      )
    } catch (error) {
      toast.error('Something went wrong')
    }
  }

  async function onPlaylistRemove(playlistId) {
    analytics.track('Deleting playlist')

    setPlaylists((prev) => {
      const updated = deleteItem({
        items: prev,
        itemID: playlistId,
      })

      mutatePlaylists(updated, false)

      return updated
    })

    await api.delete(`/playlists/${playlistId}`)
  }

  function handleMenuClick(key) {
    analytics.track('Playlist option clicked', { key })

    switch (key) {
      case 'edit-title':
        setModal({
          isEdit: true,
          title: 'Update Title',
          value: playlist.title,
          onClick: (e, newTitle) => updateTitle(newTitle),
        })
        break

      case 'delete':
        setModal({
          isConfirm: true,
          title: 'Delete Playlist',
          body: (
            <span>
              Are you sure you want to delete this playlist?
              <br />
              <span className="text-red-600 font-bold mt-3">
                All your videos within this playlist will be removed.
              </span>
            </span>
          ),
          onClick: () => onPlaylistRemove(playlist._id),
        })
        break

      default:
        break
    }
  }

  const options = [
    {
      name: 'Edit Title',
      value: 'edit-title',
      icon: (
        <Edit2 className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      ),
    },
    {
      name: 'Delete',
      value: 'delete',
      icon: (
        <Trash className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      ),
    },
  ]

  return (
    <Dropdown
      options={options}
      onChange={handleMenuClick}
      className={className}
    >
      <MoreHorizontal
        className="text-primary"
        style={{ width: '20px', minWidth: '20px' }}
      />
    </Dropdown>
  )
}
